'use client'

import { useEffect } from 'react'

import { useSession, useTenant } from '@rewardops/auth'

import { ContentfulPageById } from '~/components/contentful/page'
import { AirCanadaHomePageEvent } from '~/custom/air-canada/events/air-canada-home-page-event'

export function HomePageClient() {
  const { data: session } = useSession()
  const tenant = useTenant()

  useEffect(() => {
    localStorage.removeItem('checkout_storage')
  }, [])

  return (
    <div>
      <AirCanadaHomePageEvent />
      {session?.user &&
      session?.user?.member?.role &&
      tenant?.flags?.pawDashboard ? (
        <ContentfulPageById pageId="paw-dashboards" />
      ) : (
        <ContentfulPageById pageId="home-page" />
      )}
    </div>
  )
}
